/**
 * batch-70 app-dashboard (FO-526) - de pure regels van Systeem > App dashboard:
 * CHANGELOG lezen, "waar" bepalen, de specs-index, en secties plus specs omzetten
 * naar wijzigingen met een stabiele sleutel. Gedeeld door api, script en drift-tests.
 */
import type { AppWijzigingStatus } from '@streep/types'

export * from './hash'
export * from './waar'
export * from './changelog'
export * from './specs'
export * from './wijzigingen'
export * from './landingen'

/**
 * De status van een wijziging uit de bronnen (spec 226 §3.B8, A5): live als een
 * deploy hem bevatte; gebouwd als hij op main staat (een CHANGELOG-sectie) of de
 * spec zegt dat hij gebouwd is; in bouw als een lopende batch hem bouwt; anders
 * ontwerp. TERUGGEDRAAID zet alleen een ADMIN (vastgezet).
 */
export function bepaalWijzigingStatus(i: {
  live: boolean
  aantalSecties: number
  specStatusSoort: 'ONTWERP' | 'GEBOUWD' | null
  inBouw: boolean
}): AppWijzigingStatus {
  if (i.live) return 'LIVE'
  if (i.aantalSecties > 0 || i.specStatusSoort === 'GEBOUWD') return 'GEBOUWD'
  if (i.inBouw) return 'IN_BOUW'
  return 'ONTWERP'
}
